export const EMDASH_UNICODE = ' \u2014 ';
